import get from 'lodash/get';
import entity from './entity';

const {
  getAllFromState,
  getByIdFromState,
} = entity;

const baseSelector = state => get(state, 'entities.notifications');

const getAllNotifications = state => get(getAllFromState(state), 'data');
const getIsLoading = state => get(getAllFromState(state), 'isLoading');
const getNotificationsError = state => get(getAllFromState(state), 'error');
const getNotification = id => state => get(getByIdFromState(state, id), 'data');

const getTotalElements = state => get(baseSelector(state), 'pagination.totalElements');
const getHasMoreNotifications = state => get(baseSelector(state), 'pagination.hasMore');
const getPageNumber = state => get(baseSelector(state), 'pagination.pageNumber');
const getPageSize = state => get(baseSelector(state), 'pagination.pageSize');

const getUnseenCount = state => get(baseSelector(state), 'unseenCount.value', 0);
const getUnseenCountLoading = state => get(baseSelector(state), 'unseenCount.isLoading');
const getUnseenCountError = state => get(baseSelector(state), 'unseenCount.error');

const getMarkAsSeenLoading = state => get(baseSelector(state), 'markAsSeen.isLoading');
const getMarkAsSeenError = state => get(baseSelector(state), 'markAsSeen.error');

export {
  getAllNotifications,
  getNotification,
  getIsLoading,
  getNotificationsError,
  getTotalElements,
  getHasMoreNotifications,
  getPageNumber,
  getPageSize,
  getUnseenCount,
  getUnseenCountLoading,
  getUnseenCountError,
  getMarkAsSeenLoading,
  getMarkAsSeenError,
};

export default {
  getAllNotifications,
  getNotification,
  getIsLoading,
  getNotificationsError,
  getTotalElements,
  getHasMoreNotifications,
  getPageNumber,
  getPageSize,
  getUnseenCount,
  getUnseenCountLoading,
  getUnseenCountError,
  getMarkAsSeenLoading,
  getMarkAsSeenError,
};
